import usePermission from 'lib/hooks/usePermission';
import { Permission } from 'lib/permissions';

type InquiryRunPermission =
  | Permission.InquiryTemplateView
  | Permission.WorkflowRunList
  | Permission.WorkflowView;

export type InquiryRunPermissionMap = Record<InquiryRunPermission, boolean>;

/**
 * @name `useInquiryRunPermissionMap`
 *
 * A hook that returns a map of permissions needed to render deep links and
 * other contextual data in the inquiry run timeline + modal to the enabled states.
 *
 * Note that inquiry.view is the only permissions required to render the inquiry run
 * timeline. Currently the supplementary permissions include inquiry template, workflow run,
 * and workflow, but may grow as the timeline encompasses more event types
 */
export default (): InquiryRunPermissionMap => {
  const hasTemplateViewPermission = usePermission(Permission.InquiryTemplateView);
  const hasWorkflowRunListPerms = usePermission(Permission.WorkflowRunList);
  const hasWorkflowViewPermission = usePermission(Permission.WorkflowView);
  return {
    [Permission.InquiryTemplateView]: hasTemplateViewPermission,
    [Permission.WorkflowRunList]: hasWorkflowRunListPerms,
    [Permission.WorkflowView]: hasWorkflowViewPermission,
  };
};
